// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/myPortfolios/cards/linkStyle.css
// module id = 1511
// module chunks = 0